import { api as dataEnteringApi } from "../api";

interface Author {
    id: number;
    username: string;
    role: string;
    layout: string;
}

export interface Annotation {
    id: number;
    content: string;
    createdAt: string;
    documentId: number;
    accountId: number;
    source: "manual" | "auto";
    author: Author | null;
}

interface GetAnnotationsParams {
    accountId: number;
    documentId: number;
}

export const annotationsApi = dataEnteringApi.injectEndpoints({
    endpoints: (build) => ({
        getAnnotations: build.query<Annotation[], GetAnnotationsParams>({
            query: (params) => ({
                url: "api/v1/annotations",
                params: {
                    account_id: params.accountId,
                    document_id: params.documentId,
                },
            }),
            transformResponse: (response: { items: Annotation[] }) =>
                [...(response.items || [])].sort(
                    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
                ),
        }),
    }),
});

export const { useGetAnnotationsQuery } = annotationsApi;
